export const APP_STORE_URL =
  (process.env.REACT_APP_APP_DOWNLOAD_URL || '').trim() ||
  'https://apps.apple.com/tr/app/make-me-joi/id6762007933?l=tr';

export const PLAY_STORE_URL =
  (process.env.REACT_APP_PLAY_STORE_URL || '').trim() ||
  'https://play.google.com/store/apps/details?id=com.mmjall.mmj&hl=tr';

/** @returns {'android' | 'ios' | 'other'} */
export function detectAppPlatform() {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';
  return 'other';
}

export function getAppStoreUrlForPlatform(platform = detectAppPlatform()) {
  if (platform === 'android') return PLAY_STORE_URL;
  return APP_STORE_URL;
}

export function getAppStoreLabelForPlatform(platform = detectAppPlatform()) {
  if (platform === 'android') return 'Google Play';
  return 'App Store';
}
